import { createFileRoute } from '@tanstack/react-router';
import { DiagnosticPage } from '@/features/diagnostic/DiagnosticPage';

export const Route = createFileRoute('/diagnostic')({
  component: DiagnosticPage,
});
